const iconChallenges = require('@/assets/icons/icon-challenges.svg');
const iconStar = require('@/assets/icons/icon-stars.svg');
const iconRewards = require('@/assets/icons/icon-rewards.svg');
const iconBadges = require('@/assets/icons/icon-badges.svg');
const iconProgress = require('@/assets/icons/icon-progress.svg');

module.exports = [
  {
    id: 0,
    title: 'My Challenges',
    icon: iconChallenges,
    color: '#C9F0A7',
    router: '/challenge-child-approve',
  },
  {
    id: 1,
    title: 'My Stars To Spend',
    icon: iconStar,
    color: '#FFE27E',
    router: '/rewards',
  },
  {
    id: 2,
    title: 'My Rewards',
    icon: iconRewards,
    color: '#FBCA7E',
    router: '/rewards',
  },
  {
    id: 3,
    title: 'My Badges',
    icon: iconBadges,
    color: '#8FE9CC',
    router: '/badges',
  },
  {
    id: 4,
    title: 'My Progress',
    icon: iconProgress,
    color: '#AADBFF',
    router: '/progress',
  },
];
